<div>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div
        class="v4-layout-field-label"
        [innerHTML]="
          'automation-edit_deposit_html_title'
            | translate
              : {
                  guest: detail?.send_to,
                  currency: detail?.deposit_currency | currencyToSymbol,
                  amount: detail?.pending_refund
                }
        "></div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="w-1/2 pr-2">
            <nz-date-picker
              formControlName="plan_date"
              class="w-full"
              nzSize="large"
              [nzDisabled]="true"
              [nzFormat]="angularDateFormat"></nz-date-picker>
          </div>
          <div class="w-1/2 pl-2">
            <nz-time-picker
              formControlName="plan_time"
              class="w-full"
              nzSize="large"
              [nzFormat]="timeFormat"
              [nzDisabled]="true"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="footer flex flex-row items-center justify-between">
      <a nz-button nzType="link" nzDanger (click)="onRemove()">
        {{ "automation-edit_message_html_移除" | translate }}
        <!-- Remove -->
      </a>
      <div class="ml-auto">
        <button class="mr-3" nz-button nzSize="large" (click)="displayDeducteModal(deductedTpl)">
          {{ "deposit.list.table.op.deduct" | translate }}
          <!-- {{ "automation-edit_price_html_立即调整" | translate }} -->
          <!-- Adjust now -->
        </button>
        <button nz-button nzType="primary" nzSize="large" (click)="displayReturnModal()">
          {{ "automation-edit_deposit_html_退款" | translate }}
          <!-- {{ "word.save" | translate }} -->
          <!-- Save -->
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #deductedTpl>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="deductForm">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "deposit.list.deduct.form_item.label" | translate }}
        <!-- 请输入准备扣除的金额 -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input type="number" nz-input formControlName="amount" nzSize="large" />
        </div>
        <div class="v4-layout-field-extra">
          <span class="s1">
            {{
              "deposit.list.deduct.form_item.paid"
                | translate
                  : {
                      number:
                        (deductForm.get("deposit_currency").value | currencyToSymbol) + deductForm.get("paid").value
                    }
            }}
            <!-- 已收 {{ currentDeposit.paid }} -->
          </span>
          <span class="s2">
            {{
              "deposit.list.table.td.pending_refund"
                | translate
                  : {
                      number:
                        (deductForm.get("deposit_currency").value | currencyToSymbol) +
                        (deductForm.get("paid").value - deductForm.get("amount").value | number: "1.0-3")
                    }
            }}
            <!-- 待退 {{ currentDeposit.paid -
        currentDeposit.waitDeductedDeposit | number:
          '1.0-3' }} -->
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
